import { TRoomDetail } from '@/entities/room'

import { Heading } from '../common'

export type Props = Pick<TRoomDetail, 'description'>

export const Introduction = ({ description }: Props) => {
  return (
    <section className="space-y-3">
      <Heading>방 소개</Heading>
      <p className="typo-body2-reading font-normal whitespace-break-spaces text-gray-900">
        {description}
      </p>
    </section>
  )
}
